module.exports = __webpack_public_path__ + "img/c07_unitstartecheyeofodin_Normal_ua.852d8ff0.webp";